import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchLeveringen, initialData } from '../services/fetchLeveringen'

export { useLeveringen }

const queryKey = 'hoofdnet-leveringen'

const useLeveringen = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isError } = useQuery({
    queryFn: () => fetchLeveringen(id),
    queryKey: [queryKey, id],
    enabled: hasPermissions && !!id,
  })

  return {
    data: data || initialData.data,
    isError,
  }
}
